import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import IntroField, { IIntroFieldProps } from "../Components/IntroField";

/** A Text Field for gathering the First Name.
 * Controlled from the Session Context.
 */
const SessionContextFirstNameField = SessionContextValueProvider({
  Component: IntroField,
  map: ({ unverifiedCustomer, setCustomer, setUnverifiedCustomer }) => {
    return {
      value: unverifiedCustomer.firstName,
      onChangeValue: (firstName: string) => setUnverifiedCustomer(c => ({ ...c, firstName: firstName })),
      onChange: (firstName: string) => setCustomer(c => ({ ...c, firstName: firstName }))
    } as IIntroFieldProps;
  }
});

export default SessionContextFirstNameField;
